
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"clip-rule":"evenodd","d":"M1 20s6-9 15-9 15 9 15 9-6 9-15 9-15-9-15-9Z","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"clip-rule":"evenodd","d":"M12 20a4 4 0 0 1 4-4v0a4 4 0 0 1 4 4v0a4 4 0 0 1-4 4v0a4 4 0 0 1-4-4v0Z","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","d":"M16 4v2M23.658 6.061l-.913 1.78M29.59 10.329l-1.511 1.312"}}),_c('circle',{attrs:{"cx":"19.5","cy":"17.5","r":"2.5","fill":"currentColor"}}),_c('circle',{attrs:{"cx":"19.5","cy":"17.5","r":"2.5","stroke":"currentColor"}}),_c('path',{attrs:{"stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","d":"m8.117 6.061.913 1.78M2.186 10.329l1.51 1.312"}})])
          )
        }
      }
    